import React from "react";

const Header = () => {
  return <h1>Login</h1>;
};

export default Header;
